import React from "react";

import { ProfileLink } from "app/links";
import { Trans } from "app/utils";

import LazyEditorOutput from "components/editor/LazyEditorOutput";

import FeedItemTitle from "./FeedItemTitle";

const AnnouncementUpdated = ({ item }) => {
  const announcement = item.entity;

  return (
    <div className="FeedItem__preview__announcement_updated">
      <FeedItemTitle item={item} date={item.bumpedAt}>
        <ProfileLink user={item.users[0]} />
        {" "}
        <Trans>updated the featured content: {announcement.title}</Trans>
      </FeedItemTitle>
      <LazyEditorOutput output={announcement.body} />
    </div>
  );
};

export default AnnouncementUpdated;
